import { render, staticRenderFns } from "./GlobalParticipants.vue?vue&type=template&id=375935a4&scoped=true"
import script from "./GlobalParticipants.vue?vue&type=script&lang=ts"
export * from "./GlobalParticipants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375935a4",
  null
  
)

export default component.exports